export const CALENDAR_DETAIL_CLOSE_EVENT = 'streamlain:calendar-detail-close';
export const CALENDAR_DETAIL_TARGET_EVENT = 'streamlain:calendar-detail-target';

export interface CalendarDetailTarget {
  detailOnly: boolean;
  occurrenceStart: string | null;
  rowId: string | null;
  viewId: string | null;
}
